/**
 * Stylis plugin that expands standard `line-clamp` into the equivalent -webkit- declarations.
 * Allows writing only `line-clamp: N` in Emotion/styled without any -webkit- in source;
 * prefixes are added at runtime when this cache is used.
 */
import type { StylisPlugin } from '@emotion/cache';

const DECLARATION = 'decl';

const LINE_CLAMP_RE = /line-clamp\s*:\s*(\d+)\s*;?/i;

export const lineClampStylisPlugin: StylisPlugin = (element) => {
    if (element.type !== DECLARATION || typeof element.value !== 'string') {
        return;
    }
    const match = element.value.match(LINE_CLAMP_RE);
    if (!match) {
        return;
    }
    const n = match[1];
    element.return = [
        'display:-webkit-box',
        '-webkit-box-orient:vertical',
        `-webkit-line-clamp:${n}`,
        `line-clamp:${n}`,
        'overflow:hidden'
    ].join(';');
};
